<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11.637"
    height="11.637"
    viewBox="0 0 11.637 11.637"
  >
    <path
      id="call"
      d="M11.428,10.082a2.744,2.744,0,0,1-2.772,1.545,8.841,8.841,0,0,1-4-1.655A13.18,13.18,0,0,1,.515,5.034,4.144,4.144,0,0,1,.684.738,1.645,1.645,0,0,1,2,0c.8-.039.909.417,1.183,1.128.2.531.476,1.074.628,1.625C4.092,3.783,3.1,3.826,2.97,4.666c-.078.53.564,1.241.854,1.618A7.84,7.84,0,0,0,5.848,8.148c.442.279,1.154.78,1.66.5.779-.427.706-1.74,1.794-1.3a17.525,17.525,0,0,1,1.649.851c.832.448.794.912.476,1.875h0"
      transform="translate(0 0)"
      fill="#fff"
      fill-rule="evenodd"
    />
  </svg>
</template>
